class API {

    static BinariesData = '/api/BinariesData'
    static Authentications = '/api/Authentications'
    static AuthenticationsSignOut = '/api/Authentications/SignOut'

    static AuthenticationsForgottenPassword = '/api/Authentications/ForgottenPassword'
    static AuthenticationsResetPassword = '/api/Authentications/ResetPassword'
    static AuthenticationsNewPassword = '/api/Authentications/NewPassword'

    static OrdersView = '/api/Orders/View'
    static TransactionalDocumentsView = '/api/TransactionalDocuments/View'
    static TransactionalDocument= '/api/TransactionalDocuments'
    static Countries = '/api/Dictionaries/Country'
    static ComplaintExpectation = '/api/Dictionaries/ComplaintExpectation'
    static ComplaintsDocumentsView ='/api/ComplaintsDocuments/View'
    static ComplaintsDocuments ='api/ComplaintsDocuments'
    static NewRealization ='/api/ComplaintsDocuments/Realization'
    
    static ProductsTerms = '/api/ProductsTerms'
    static ProductsTermsCalendar = '/api/ProductsTerms/Calendar'
}

export default API